
import { CurrencyApi } from "@/api/CurrencyApi";
import { ProviderApi } from "@/api/ProviderApi";
import { ProviderInvoiceCategoryApi } from "@/api/ProviderInvoiceCategoryApi";
import { FormConfigType } from "@/types/dynamicForm";
import { RADIO_INPUT_TYPE, SELECT_INPUT_TYPE, VALIDATION_ERROR_MESSAGE, Yup } from "@mavichpe/dynamic-forms";
import { PROVIDER_INVOICE_TYPES } from "@utils/Constants";
import { generateCurrencyOptionLabel } from "@utils/Currency";
import { CurrencyIdPubSub } from "@utils/pubsubs/PubSub";

const ProviderInvoiceFormConfig: FormConfigType = {
    sections: [
        {
            hideBorderBottom: true,
            "fields": [
                [
                    {
                        "type": "text",
                        "name": "reference_number",
                        "label": "Numero Referencia",
                        "isHorizontal": true,
                        "visibilityHiddenIf": () => true, // by default this input is hidden, suscrption data make it visible
                        "labelSizing": {
                            "sm": {
                                "size": 2
                            }
                        },
                        "sizing": {
                            "sm": {
                                "size": 2
                            }
                        },
                    },
                ],
                [
                    {
                        "type": SELECT_INPUT_TYPE,
                        "name": "currencyId",
                        "label": "Moneda",
                        "optionsFunction": () => CurrencyApi.optionsList({}, (i) => generateCurrencyOptionLabel(i)),
                        "onChangePubSub": (value: string) => CurrencyIdPubSub.publish({ currencyId: value }),
                        "isHorizontal": true,
                        "labelSizing": {
                            "sm": 2
                        },
                        "sizing": {
                            "sm": 4
                        },
                        "validation": Yup.string().required(VALIDATION_ERROR_MESSAGE.REQUIRED_FIELD_ERROR),
                    },
                ],
                [
                    {
                        "type": RADIO_INPUT_TYPE,
                        "name": "tipo",
                        "isHorizontal": true,
                        "validation": Yup.string().required(),
                        "label": "Tipo Factura",
                        "labelSizing": {
                            "sm": {
                                "size": 2
                            }
                        },
                        "sizing": {
                            "sm": {
                                "size": 6
                            }
                        },
                        "options": PROVIDER_INVOICE_TYPES,
                        "defaultValue": 0,
                    }
                ],
                [
                    {
                        "type": SELECT_INPUT_TYPE,
                        "name": "providerInvoiceCategoryId",
                        "label": "Categoria Compra",
                        "optionsFunction": () => ProviderInvoiceCategoryApi.optionsList(),
                        "isHorizontal": true,
                        "labelSizing": {
                            "sm": 2
                        },
                        "sizing": {
                            "sm": 6
                        },
                        "validation": Yup.string().required(VALIDATION_ERROR_MESSAGE.REQUIRED_FIELD_ERROR),
                    },
                ],
                [
                    {
                        "type": SELECT_INPUT_TYPE,
                        "name": "providerId",
                        "label": "Provedor",
                        "optionsFunction": () => ProviderApi.optionsList(),
                        "isHorizontal": true,
                        "labelSizing": {
                            "sm": 2
                        },
                        "sizing": {
                            "sm": 6
                        },
                        "validation": Yup.string().required(VALIDATION_ERROR_MESSAGE.REQUIRED_FIELD_ERROR),
                    },
                ],
                [
                    {
                        "type": "text",
                        "name": "numero",
                        "label": "Numero Factura",
                        "isHorizontal": true,
                        "sizing": {
                            "sm": 4
                        },
                        "labelSizing": {
                            "sm": 2
                        },
                        "validation": Yup.string().required(VALIDATION_ERROR_MESSAGE.REQUIRED_FIELD_ERROR),
                    },
                ],
                [
                    {
                        "type": "text",
                        "name": "sequence",
                        "label": "Numero Consecutivo",
                        "isHorizontal": true,
                        "sizing": {
                            "sm": 5
                        },
                        "labelSizing": {
                            "sm": 2
                        },
                        "validation": Yup.string().required(VALIDATION_ERROR_MESSAGE.REQUIRED_FIELD_ERROR),
                    },
                ],
                [
                    {
                        "type": "text",
                        "name": "document_key",
                        "label": "Clave Numerica",
                        "isHorizontal": true,
                        "sizing": {
                            "sm": 6
                        },
                        "labelSizing": {
                            "sm": 2
                        },
                        "validation": Yup.string().required(VALIDATION_ERROR_MESSAGE.REQUIRED_FIELD_ERROR),
                    },
                ],
                [
                    {
                        "type": "date",
                        "name": "fecha",
                        "label": "Fecha",
                        "isHorizontal": true,
                        "labelSizing": {
                            "sm": 2
                        },
                        "sizing": {
                            "sm": 3
                        },
                        "validation": Yup.string().required(VALIDATION_ERROR_MESSAGE.REQUIRED_FIELD_ERROR),
                    },
                ],
                [
                    {
                        "type": "number",
                        "name": "exchange_rate",
                        "label": "Tipo de Cambio",
                        "isHorizontal": true,
                        "labelSizing": {
                            "sm": 2
                        },
                        "sizing": {
                            "sm": 2
                        },
                        "validation": Yup.string().required(VALIDATION_ERROR_MESSAGE.REQUIRED_FIELD_ERROR),
                    },
                ],
                [
                    {
                        "type": "money",
                        "name": "subtotal",
                        "label": "Subtotal",
                        "isHorizontal": true,
                        "labelSizing": {
                            "sm": 2
                        },
                        "sizing": {
                            "sm": 3
                        },
                        "validation": Yup.string().required(VALIDATION_ERROR_MESSAGE.REQUIRED_FIELD_ERROR),
                    },
                ],
                [
                    {
                        "type": "money",
                        "name": "descuento",
                        "label": "Descuento",
                        "isHorizontal": true,
                        "labelSizing": {
                            "sm": 2
                        },
                        "sizing": {
                            "sm": 3
                        },
                        "validation": Yup.string().required(VALIDATION_ERROR_MESSAGE.REQUIRED_FIELD_ERROR),
                    },
                ],
                [
                    {
                        "type": "money",
                        "name": "impuestos",
                        "label": "Impuestos",
                        "isHorizontal": true,
                        "labelSizing": {
                            "sm": 2
                        },
                        "sizing": {
                            "sm": 3
                        },
                        "validation": Yup.string().required(VALIDATION_ERROR_MESSAGE.REQUIRED_FIELD_ERROR),
                    },
                ],
                [
                    {
                        "type": "money",
                        "name": "total",
                        "label": "Total",
                        "isHorizontal": true,
                        "labelSizing": {
                            "sm": 2
                        },
                        "sizing": {
                            "sm": 3
                        },
                        "validation": Yup.string().required(VALIDATION_ERROR_MESSAGE.REQUIRED_FIELD_ERROR),
                    },
                ],
            ]
        }
    ],
};


export default ProviderInvoiceFormConfig;